import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../../actions';

export interface NewsState {
  isFilterCollapsed: boolean;
  isFilterModalVisible: boolean;
}

const initialState: NewsState = {
  isFilterCollapsed: true,
  isFilterModalVisible: false,
};

export const newsSlice = createSlice<NewsState, SliceCaseReducers<NewsState>>({
  name: '@@eskmo/runtime/news',
  initialState,
  reducers: {
    setFilterCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isFilterCollapsed = action.payload;
    },
    setFilterModalVisible: (state, action: PayloadAction<boolean>) => {
      state.isFilterModalVisible = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const news = newsSlice.reducer;
